module.exports = __webpack_public_path__ + "img/capt_c.2b762fb2.jpg";